import React, { useEffect, useState } from 'react';
import OrgChart from 'react-orgchart';
import 'react-orgchart/index.css';
import { useCentralCalls } from '@src/rest/CentralCalls';
import { DashChartProps } from '../DashCard';

const MyNodeComponent = ({ node }) => (
  <div className="org-node">
    {node.name}
  </div>
);

const DashOrgChart: React.FC<DashChartProps> = ({ item, projectVersionId, userId, projectId}) => {
  const [data, setData] = useState(null); // State to store the org chart data
  const {  executeStoredProcedure } = useCentralCalls(); // Assuming this is the API call function

  useEffect(() => {
    
    const fetchChartData = async () => {
      try {
        console.log('fetching chart data..');
        console.log(item);
        console.log(projectVersionId);
        const data = await executeStoredProcedure(item.procedureName,{ projectVersionId: projectVersionId, userId:userId, projectId });
        console.log(data);
        setData({ name: "Root", children: data }); 
        //setData(data);
        //if(data.datasets.length === 1){}
      } catch (error) {
        console.error('Error fetching Gantt data:', error);
      }
    };
    fetchChartData();
  }, [projectVersionId,item]);

  // Render only after data is loaded
  if (!data) return <div>Loading...</div>;

  return <OrgChart tree={data} NodeComponent={MyNodeComponent} />;
};

export default DashOrgChart;